<div container>
  <div class="callout bg-light d-flex flex-column flex-lg-row gap-3 gap-lg-0">
    <div
      class="callout__img bg-white text-center d-flex justify-content-center"
      [ngClass]="{'py-3': data.icon === 'antibodies' }"
    >
      <img
        class="img-fluid"
        [src]="'/assets/img/callout/' + data.icon + '.svg'"
        [alt]="data.alt || ''"
      />
    </div>
    <div class="callout__text text-center text-lg-start">
      <h3 [innerHTML]="data.title"></h3>
      <p class="mb-0" [innerHTML]="data.text"></p>
    </div>
  </div>
</div>
